<template>
  <BuilderWrapper
    title="Scale Factor"
    helpful-tip="The scale factor can be used to increase the size of small bubbles for an entire tab."
  >
    <b-checkbox v-model="customiseTabScaleFactor">
      Customise scale factor
    </b-checkbox>

    <template v-if="customiseTabScaleFactor">
      <b-form-text v-if="bubblesVisualisationActive">
        Note: Bubble size is constrained by the maximum bubble size setting
      </b-form-text>
      <ScaleFactorTab
        v-for="path in tabs"
        :key="path.toString()"
        :path="path"
      />
    </template>
  </BuilderWrapper>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import ScaleFactorTab from '@/components/builder/ScaleFactorTab.vue'
import BuilderWrapper from '@/components/builder/UI/BuilderWrapper.vue'

const components = {
  ScaleFactorTab,
  BuilderWrapper,
}

@Component({ components })
export default class ScaleFactorSettings extends Vue {
  get customiseTabScaleFactor () {
    return this.$typedStore.primary.app.config.appConfig.customiseTabScaleFactor
  }

  set customiseTabScaleFactor (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: ['appConfig', 'customiseTabScaleFactor'],
      value,
    })
  }

  get tabs () {
    return this.$typedStore.visualisationData.sortedRootChildren.map(item => item.path)
  }

  get bubblesVisualisationActive () {
    return this.$typedStore.activeVisualisation.isBubbles
  }
}
</script>
